module.exports = __webpack_public_path__ + "static/pattern-1-20696ccea54bae48094f54dd388968e6.svg";